import React, { useState, useEffect } from 'react';
import ApiAlunos from '../services/alunoService';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import InputCPF from "../components/InputCpf";
//import ReCAPTCHA from 'react-google-recaptcha';
//import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const CadastroAtletaFormulario = ({ academias }) => {
    const { slug } = useParams();
    const [showForm, setShowForm] = useState(true);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [cpf, setCpf] = useState('');
    const [cpfValido, setCpfValido] = useState("");
    const [academiaId, setAcademiaId] = useState('');
    const [genero, setGenero] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [image, setImage] = useState('');
    const [academiaBloqueada, setAcademiaBloqueada] = useState(false);

    const handleFileChange = (e, setFileState) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const response ={'media_url': e.target.result, 'media_from':'file_upload', 'name':file.name};
            setFileState(response, URL.createObjectURL(file));
        };
        reader.readAsDataURL(file);
    }

    const formatCpf = (value) => {
        return value
            .replace(/\D/g, '') // remove tudo que não for número
            .replace(/^(\d{3})(\d)/, '$1.$2')
            .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1-$2')
            .slice(0, 14); // limita tamanho
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            nome: nome,
            email: email,
            academia_id: academiaId,
            sexo: genero,
            cpf: cpf,
            foto: image,
            data_nascimento: dataNascimento,
            active: 'yes',
            status: "INATIVO"
        };

        try {
            const response = await ApiAlunos.novoAtleta(data);
            if (response.status === 'success') {
                setShowForm(false);
                Swal.fire({
                  title: 'Sucesso!',
                  text: 'Recebemos seus dados com sucesso, aguarde novidades através do email cadastrado!',
                  icon: 'success',
                  confirmButtonText: 'Ok'
                })
            } else {
                Swal.fire({
                  title: 'Houve um erro ao cadastrar o(a) atleta!',
                  text: response.message,
                  icon: 'error',
                  confirmButtonText: 'Ok'
                })
            }
        } catch (error) {
            Swal.fire({
                title: 'Houve um erro ao cadastrar o(a) atleta!',
                text: error,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
        }
    };

    useEffect(() => {
    if (!Array.isArray(academias) || academias.length === 0) return;

    const normalize = (str) =>
        str
            ?.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();

    const slugNormalizado = normalize(slug);

    const academiaEncontrada = academias.find(
        (a) => normalize(a.url) === slugNormalizado
    );

    if (academiaEncontrada) {
        setAcademiaId(String(academiaEncontrada.id));
        setAcademiaBloqueada(true); // 🔒 bloqueia edição
    }
}, [academias, slug]);

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-10 offset-lg-1">
                    <div className="contact_form_wrapper">
                        {!showForm &&
                            <h3>Recebemos seus dados com sucesso, aguarde novidades através do email cadastrado!</h3>
                        }
                        {showForm &&
                            <form
                                name="contactForm"
                                id="contact_form"
                                className="form-border"
                                onSubmit={handleSubmit}
                            >
                                <div className="row">
                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Nome Completo</span>
                                        <input
                                            required
                                            type="text"
                                            name="nome"
                                            className="form-control"
                                            placeholder="Nome Completo"
                                            onChange={(event) => setNome(event.target.value)}
                                        />
                                    </div>
                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Cpf</span>

                                        <InputCPF
                                            value={cpf}
                                            onChange={setCpf}
                                            onValidChange={(valido) => setCpfValido(valido)}
                                            required
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Email</span>
                                        <input
                                            required
                                            type="email"
                                            name="Email"
                                            className="form-control"
                                            placeholder="Seu Email"
                                            onChange={(event) => setEmail(event.target.value)}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <div className="field-set">
                                            <label>Data de Nascimento</label>
                                            <input 
                                                type='date' 
                                                value={dataNascimento} 
                                                required 
                                                className="form-control"
                                                placeholder="Sua Data de Nascimento"
                                                onChange={(event) => setDataNascimento(event.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Gênero</span>
                                        <select
                                            required
                                            name="tipo_de_vinculacao"
                                            className="form-control"
                                            onChange={(event) => setGenero(event.target.value)}
                                        >
                                            <option value="">:: Selecione ::</option>
                                            <option value="Feminino">Feminino</option>
                                            <option value="Masculino">Masculino</option>
                                        </select>
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <span className="d-label">Foto</span>
                                        <input
                                            required
                                            type="file"
                                            onChange={(event) => handleFileChange(event, setImage)}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="field-set col-lg-6 mb10">
                                        <label>Academia</label>

                                        <select
                                            className="form-control"
                                            value={academiaId}
                                            onChange={(e) => setAcademiaId(e.target.value)}
                                            required
                                            disabled={academiaBloqueada}
                                        >
                                            <option value="">Selecione uma academia</option>

                                            {academias.map((academia) => (
                                                <option key={academia.id} value={academia.id}>
                                                    {academia.razaoSocial}
                                                </option>
                                            ))}
                                        </select>
                                    </div>


                                    
                                </div>

                                <div className="col-12">
                                    {/* <ReCAPTCHA
                                        sitekey=""
                                        onChange={handleRecaptcha}
                                    /> */}
                                    <div id="submit" className="mt30">
                                        <button type="submit" id="send_message" className="btn-main">
                                            Enviar Solicitação de Cadastro
                                        </button>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CadastroAtletaFormulario;